import { Bot, ClipboardList, BookOpen, Film, Dumbbell, ShieldCheck } from "lucide-react";

// American football stock imagery (Pexels — verified American football, not soccer)
export const HERO_IMG =
  "https://images.pexels.com/photos/23897798/pexels-photo-23897798.jpeg?auto=compress&cs=tinysrgb&w=1920";
export const ACTION_IMG =
  "https://images.pexels.com/photos/274517/pexels-photo-274517.jpeg?auto=compress&cs=tinysrgb&w=1920";
export const HUDDLE_IMG =
  "https://images.pexels.com/photos/1147455/pexels-photo-1147455.jpeg?auto=compress&cs=tinysrgb&w=1600";

export const FEATURES = [
  {
    icon: Bot,
    title: "AI Football Coach",
    body: "GPT-powered coordinator that knows your playbook, your culture, and your opponent film. Ask a question in the elevator, get a coordinator-caliber answer.",
    testid: "feature-ai-coach",
  },
  {
    icon: ClipboardList,
    title: "Practice Planner",
    body: "Drag-and-drop practice builder with printable field cards. Every period tied to plays, drills, and personnel — no more whiteboard photos.",
    testid: "feature-practice",
  },
  {
    icon: BookOpen,
    title: "Living Playbook",
    body: "Interactive play diagrams with custom slots, hot routes, and halved markers. Your install document that actually stays current.",
    testid: "feature-playbook",
  },
  {
    icon: Film,
    title: "Film Hub + AI Scout",
    body: "Store opponent film links. One click produces a Scout Report: tendencies, formations, and what to attack — before your Monday meeting.",
    testid: "feature-film",
  },
  {
    icon: Dumbbell,
    title: "Drill Library",
    body: "Every drill categorized by position, phase, and install day. Wire them into practice periods with a drag. Coach it once. Use it forever.",
    testid: "feature-drills",
  },
  {
    icon: ShieldCheck,
    title: "Program Identity",
    body: "Culture, standards, staff manual, and player handbook — the philosophy your seniors carry into the locker room every fall.",
    testid: "feature-identity",
  },
];

export const STATS = [
  { n: "6", label: "Modules On Day One" },
  { n: "1", label: "Command Center" },
  { n: "24/7", label: "AI Coordinator On Call" },
];
